import { Box, Paper, Stack, Typography } from "@mui/material"
import React from "react"
import defColors from "utils/defColors"

const data = [
    [
        { value: '(Km/h)', color: defColors.backgroundColor },
        { value: '도시부', color: defColors.backgroundColor },
        { value: '지방부', color: defColors.backgroundColor },
        { value: '도시고속', color: defColors.backgroundColor },
        { value: '고속도로', color: defColors.backgroundColor }
    ],
    [
        { value: '원활', color: defColors.trafficColors[2] },
        { value: '25이상' },
        { value: '50이상' },
        { value: '50이상' },
        { value: '80이상' }
    ],
    [
        { value: '서행', color: defColors.trafficColors[1] },
        { value: '15~25' },
        { value: '30~50' },
        { value: '30~50' },
        { value: '40~80' }
    ],
    [
        { value: '정체', color: defColors.trafficColors[0] },
        { value: '15미만' },
        { value: '30미만' },
        { value: '30미만' },
        { value: '40미만' }
    ]
    ,
    [
        { value: '정보없음', color: defColors.trafficColors[3] },
        { value: '대상정보없음' }
    ]
]
export const TrafficColorTableBox = ({
    sx }) => {

    return (
        <Paper elevation={0} sx={{ p: '16px', borderRadius:'10px', backgroundColor: 'rgb(2 6 20)', ...sx }}>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={1} sx={{ width: '100%', height: '100%' }}>{data.map((p, idx1) =>
                    <Stack
                        key={idx1}
                        direction="row"
                        justifyContent="stretch"
                        alignItems="center"
                        spacing={1} sx={{ width: '100%', height: '100%' }}>
                        {p.map((q, idx2) => (
                            idx1 === 4 && idx2 === 1 ?
                            <Box sx={{width:'100%', height:'100%' ,borderRadius:'6px;'}}
                                key={idx2} bgcolor={q.color}>
                                <Typography variant={'h6'} textAlign={'center'} color={'white'}>{q.value}</Typography>
                            </Box>
                            :
                            <Box
                                key={idx2} bgcolor={q.color} minWidth={110} sx={{borderRadius: '6px' }}>
                                <Typography variant={'h6'} textAlign={'center'} color={'white'}>{q.value}</Typography>
                            </Box>
                        )
                        )}</Stack>
                )}
            </Stack>
        </Paper>
    )
}
export default TrafficColorTableBox